<div class="row">
  <div class="col">
      <h2 class="h2-responsive">Scales</h2>
      <!--TODO: stephen move this to <scales-list></scales-list>-->
      <p *ngIf="assessment.scales.length <= 0">No scales exist</p>
  </div>
</div>
<div class="row">
    <div class="col-sm-4 col-lg-3">
        <ul class="list-group flex-column">
          <li class="list-group-item" 
            [ngClass]="getClassesForScale(scale)"
            *ngFor="let scale of assessment.scales" (click)="selectedScale = scale"><a>{{scale.name}}</a></li>
        </ul>
      </div>
      <div class="col-sm-8 col-lg-9" *ngIf="!selectedScale">
        <p class="alert alert-info">Select a scale</p>
      </div>
      <div class="col-sm-8 col-lg-9" *ngIf="selectedScale">
        <div *ngFor="let range of selectedScale.ranges" class="card card-cascade mb-3">
          <div class="view gradient-card-header secondary-gradient white-text">
            <h2 class="h2-responsive">{{range.displayName}} ({{range.rangeStart}} - {{range.rangeEnd}})</h2>
          </div>
          <div class="card-body">
            <h3 class="h3-responsive p-0">Therapist Content</h3>
            <hr class="mb-2" />
            <div [innerHTML]="range.therapistContent"></div>
            <h3 class="h3-responsive p-0">Client Content</h3>
            <hr class="mb-2" />
            <div *ngIf="range.clientContent" [innerHTML]="range.clientContent"></div>
            <div *ngIf="!range.clientContent" [innerHTML]="range.therapistContent"></div>
          </div>
        </div>
      </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/scales-list-view/scales-list-view.component.html